export default "__VITE_ASSET__CGK2GmER__"